import { IvideonDealerDocsIProps } from "~/entity/Ivideon/model/schema";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

export const fromServer = (data: any[] | []) => {
  let formated = data.map((item) => {
    return {
      history: "",
      id: item.dealerId,
      dealer: item.dealerName,
      act: "",
      date: "",
      sum: "",
      buttons: "",
      acts: item.acts,
    };
  });
  return formated;
};

export interface formatForCodeListIProps {
  data: IvideonDealerDocsIProps;
  dealerActId: string;
  actId: string;
}

export const formatForCodeList = ({
  data,
  dealerActId,
  actId,
}: formatForCodeListIProps) => {
  const dealer = data.dealers.find((d) => d.dealerId === Number(dealerActId));
  const currentAct = dealer?.acts.find((a) => a.actId === Number(actId));
  const licenses = currentAct?.licenses ?? [];

  return licenses.map((item) => ({
    id: item.id,
    licenseCode: item.licenseCode,
    tariffName: item.tariffName,
    dateAct: `${dateFormat(new Date(currentAct.actStartDate), {
      type: "date",
    })} - 
              ${dateFormat(new Date(currentAct.actEndDate), { type: "date" })}`,
  }));
};
